/* Temporary legacy-cart transition, #206. Remove after carts containing the
 * retired fee and delivery properties have expired. Never clear a whole cart.
 * No product-type/collection routing: only the retired fee identifiers and
 * obsolete line properties are recognised here. */
(function (w, d) {
  if (w.fbLegacyCart206) return;
  var attempt;
  var feeVariants = ['49631783551209', '49631783583977', '49631783616745'];

  function isFee(line) {
    return String(line.product_id) === '9139678216425' ||
      feeVariants.indexOf(String(line.variant_id || line.id)) !== -1 ||
      Object.prototype.hasOwnProperty.call(line.properties || {}, '_isEventTimeSlot');
  }

  async function change(body) {
    var response = await w.fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error('Could not update the previous delivery selection.');
    return response.json();
  }

  async function refresh(cart) {
    var drawer = d.querySelector('cart-notification');
    var page = d.querySelector('cart-items');
    // Each request stays below Shopify's five-section limit. Render in place;
    // do not open the drawer or reload, and do not submit notes or attributes.
    for (var component of [drawer, page]) {
      if (!component || !component.getSectionsToRender) continue;
      var sections = component.getSectionsToRender().map(function (section) { return section.section || section.id; });
      var response = await w.fetch('/cart?sections=' + sections.join(','));
      if (!response.ok) throw new Error('Could not refresh the cart.');
      var html = await response.json();
      if (sections.some(function (id) { return !html[id]; })) throw new Error('Could not refresh the cart.');
      component.renderContents(Object.assign({}, cart, { sections: html }), false);
    }
    d.dispatchEvent(new CustomEvent('cart:updated', { detail: { parsedState: cart } }));
  }

  function run() {
    // One attempt per document, shared by load and checkout. No refresh loop or
    // automatic retry on failure. A reload offers a fresh, idempotent attempt.
    if (attempt) return attempt;
    if (!w.fbLegacyCart206Needed) return (attempt = Promise.resolve(null));
    attempt = (async function () {
      var response = await w.fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Could not read the cart.');
      var cart = await response.json();
      var changed = false;
      // Stable line keys prevent a removal shifting the index of another line.
      for (var line of cart.items || []) {
        if (isFee(line)) {
          cart = await change({ id: line.key, quantity: 0 });
          changed = true;
        }
      }
      // Use each returned cart: a property change can merge identical lines and
      // change their keys. The initial line count bounds the conversion work.
      var remaining = (cart.items || []).length;
      for (var i = 0; i < remaining; i++) {
        var line = cart.items.find(function (item) {
          return item.properties && Object.prototype.hasOwnProperty.call(item.properties, 'Delivery Time');
        });
        if (!line) break;
        var properties = Object.assign({}, line.properties);
        delete properties['Delivery Time'];
        // #206 studio cue only; remove after BloomBot reads the event-catalogue tag
        cart = await change({ id: line.key, quantity: line.quantity, properties: properties });
        changed = true;
      }
      if (changed) await refresh(cart);
      w.fbLegacyCart206Needed = false;
      return cart;
    })();
    return attempt;
  }
  // #206 studio cue only; remove after BloomBot reads the event-catalogue tag
  // Keep the app-added marker on PDP submissions and surviving cart lines.
  function sanitiseForm(formData) {
    formData.delete('properties[Delivery Time]');
  }
  w.fbLegacyCart206 = { run: run, sanitiseForm: sanitiseForm };

  function start() {
    run().catch(function (error) { console.error('[#206 legacy cart]', error.message); });
  }
  // Let the one transition settle before leaving for checkout. The replay runs
  // the ordinary checkout handlers, including HFD and account checks, once.
  var replaying = false;
  var checkoutPending = false;
  function beforeCheckout(event) {
    var target = event.target && event.target.closest && event.target.closest('#cartCheckoutButton, [name="checkout"], a[href="/checkout"]');
    if (!target || replaying || !w.fbLegacyCart206Needed) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    run().then(function () {
      checkoutPending = false;
      replaying = true;
      try { target.click(); } finally { replaying = false; }
    }).catch(function () {
      checkoutPending = false;
      w.alert('We could not update your previous delivery selection. Please refresh the page and try again.');
    });
  }
  d.addEventListener('click', beforeCheckout, true);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})(window, document);
